// import * as types from './types'
// import { showLogin } from '@/plugins/common'
import Vue from 'vue'
import { isChrome } from '@/utils/ua'
import { host } from '../config/env'
import { getProductInfo, asyncOrderCallback, getOrderStatus, getLimitInfo } from '../api/pay'
const state = {
  buyId: null,
  payLoading: false
}

const mutations = {
  setBuyId (state, id) {
    state.buyId = id
  },
  setPayLoading (state, bool) {
    state.payLoading = bool
  }
}

const actions = {
  /**
   * 海报立即使用
   */
  userHandler ({ state, rootState }, attrGroupId) {
    const url = attrGroupId === 7 ? `${host.client}/h2/create/${state.buyId}?fromMall=true` : `${host.client}/ebook/create/${state.buyId}?fromMall=true`
    if (isChrome()) {
      const newWindow = window.open()
      newWindow.location.href = url
    } else {
      window.newWindow.location.href = url
    }
  },
  /**
   * 商品购买
   */
  async payHandler ({ commit, dispatch, rootState, rootGetters }, product) {
    const userInfo = rootState.user.userInfo
    // 判断用户是否登录
    if (!userInfo) {
      this._vm.layout.showLogin()
      return false
    }
    if (!isChrome() && (product.attrGroupId === 7 || product.attrGroupId === 18)) { window.newWindow = window.open() }
    const userCanFreeUseTemplate = rootGetters['user/userCanFreeUseTemplate']
    try {
      // 免费价格为0，vip账号(7,8,9)购买VIP免费(vipfreeFlag) 走免费的流程，月卡会员购买月卡样例走免费的流程
      // vip账号(7,8,9) 可以免费使用 月卡样例
      if (
        product.attrGroupId === 7 || product.attrGroupId === 18 ||
        product.price === 0 ||
        product.discountPrice === 0 ||
        (product.memberFreeFlag && userCanFreeUseTemplate)
      ) {
        commit('setPayLoading', true)
        getProductInfo(product).then(async (res) => {
          const { id, type, pageMode } = res.data.obj
          await dispatch('asyncOrderCallback', {
            id,
            type,
            price: 0,
            pageMode,
            orderId: null,
            attrGroupId: product.attrGroupId
          })
        }).catch(e => {
          commit('setPayLoading', false)
        })
      } else {
        // 提示信息
        getLimitInfo().then(res => {
          if (res.data.map.flag === 0) {
            // 可以支付，弹出支付弹窗
            // 企业模板
            if (product.isCompanyTemp === 1) {
              // 判断是否为付费样例,是则弹出购买框
              if (res.data.type === 2 || res.data.type === 21) {
                return Promise.resolve({ free: false })
              } else {
                commit('setPayLoading', false)
                Vue.$message.error('您不是企业用户，无法使用该模板')
              }
            } else {
              return Promise.resolve({ free: false })
            }
          }
        })
      }
    } catch (e) {
      commit('setPayLoading', false)
      const data = (e.data && e.data.data) || {}
      Vue.$message.error((data.map && data.map.error) || '服务器繁忙，请稍后重试！')
    }
  },
  /**
   * 订单回调
   */
  async asyncOrderCallback ({ commit, dispatch }, params) {
    const { id, type, price, pageMode, orderId } = params
    const callbackParams = { id, type, price, pageMode, orderId }
    asyncOrderCallback({
      id: null,
      type: null,
      price: 0,
      orderId: null,
      pageMode: null,
      ...callbackParams,
      prodType: params.attrGroupId, // 场景
      source: 1
    }).then(res => {
      // 订单成功后
      let num = 0
      if (res.data.map.error === '重复提交') {
        commit('setPayLoading', false)
        Vue.$message.error('20秒之内请勿重复点击！')
        return
      }
      const orderTimer = setInterval(async () => {
        num++
        try {
          getOrderStatus({
            id: res.data.map.id
          }).then(data => {
            const status = data.data.map.status
            if (status === 1) {
              orderTimer && clearInterval(orderTimer)
              commit('setBuyId', data.data.map.callBackId)
              if (params.attrGroupId === 7 || params.attrGroupId === 18) dispatch('userHandler', params.attrGroupId)
            }
            commit('setPayLoading', false)
          }).catch(() => {
            commit('setPayLoading', false)
          })
        } catch (e) {
          commit('setPayLoading', false)
          orderTimer && clearInterval(orderTimer)
          const data = (e.data && e.data.data) || {}
          Vue.$message.error((data.map && data.map.error) || '服务器繁忙，请稍后重试！')
        }
        if (num > 20) {
          orderTimer && clearInterval(orderTimer)
          commit('setPayLoading', false)
          Vue.$message.error('操作超时')
        }
      }, 500)
    }).catch(() => {
      commit('setPayLoading', false)
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
